import styled, { css } from "styled-components";

export const Header = styled.header`
  position: relative;
  display: flex;
  width: 100vw;
  padding: 0 16px;
  background: ${(props) => props.theme.colors.white100};
  align-items: center;
  justify-content: space-between;
  z-index: 2;

  // 모바일 환경(600px 이하) 설정
  @media (max-width: 600px) {
    padding: 0 6px;
  }
`;

export const HeaderTitBox = styled.div`
  position: absolute;
  display: flex;
  width: 100vw;
  height: 80px;
  left: 0;
  top: 0;
  align-items: center;
  justify-content: center;
  z-index: 0;

  h2 {
    font-size: 1.8rem;
    font-weight: 500;
    font-family: "Pretendard";
  }

  // 모바일 환경(600px 이하) 설정
  @media (max-width: 600px) {
    height: 56px;
  }

  // 모바일 가로 모드 대응
  @media (max-height: 500px) and (orientation: landscape) {
    height: 56px; 
  }
`;

export const HeaderLeftBox = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  z-index: 1;
`;

export const HeaderRightBox = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  z-index: 1;
`;

export const AlarmButton = styled.button`
  display: flex;
  width: 40px;
  height: 40px;
  background: none;
  border: none;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
`;
